import { useCallback, useState } from 'react';
/**
 * Uses the Legacy Copy API to copy text to the clipboard.
 */
const syncCopy = (text) => {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
};
export const useCopyToClipboard = () => {
    const [state, setState] = useState();
    const copyToClipboard = useCallback(async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setState(text);
        }
        catch {
            syncCopy(text);
            setState(text);
        }
    }, []);
    return [state, copyToClipboard];
};
//# sourceMappingURL=useCopyToClipboard.js.map